var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5546 1.00109H2.15483C0.615056 0.942298 0.615056 3.28276 2.15483 3.22397H16.4972C18.0089 3.28276 18.0677 1.00109 16.556 1.00109H16.5546ZM2.15483 9.8898C0.673847 9.8898 0.673847 12.1113 2.15483 12.1113H10.2737C11.7854 12.1113 11.7854 9.8898 10.2737 9.8898H2.15483ZM2.15483 18.7785C0.673847 18.7785 0.673847 21 2.15483 21H20.348C21.829 21 21.829 18.7785 20.348 18.7785H2.15483Z",
    fill: "#333333",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/Bars.debb0fdf4f3bd686ee29e9cf1e7e95a6.svg";
export { ForwardRef as ReactComponent };